export const CLUB_LAUNCH_CHECKLIST = [
  { key: 'address', label: 'Club address', permission: 'settings.manage' },
  { key: 'profile', label: 'Subscription', permission: 'membership.manage' },
  { key: 'metadata', label: 'Club details', permission: 'settings.manage' },
  { key: 'joinForm', label: 'Join form', permission: 'membership.manage' },
  { key: 'payments', label: 'Stripe account', permission: 'finance.manage' },
];

export function getClubLaunchChecklist(checklist = {}, permissionKeys = [], options = {}) {
  const allowed = new Set(permissionKeys);
  const membershipMode = options.membershipMode || 'hosted_stripe';
  const hybrid = membershipMode === 'hybrid';
  const clubManaged = membershipMode === 'club_gated' || membershipMode === 'club_pay_later';
  return CLUB_LAUNCH_CHECKLIST
    .map((item) => ({
    ...item,
    label: item.key === 'payments' && hybrid
      ? 'Stripe & club billing card'
      : item.key === 'payments' && clubManaged
        ? 'Club billing card'
      : item.key === 'profile' && membershipMode !== 'hosted_stripe'
        ? 'Membership plans & fees'
        : item.label,
    completed: item.key === 'payments' && hybrid
      ? options.billingCardReady === true && checklist?.payments?.completed === true
      : item.key === 'payments' && clubManaged
        ? options.billingCardReady === true
      : item.key === 'profile' && hybrid
        ? options.externalPaymentReady === true && checklist?.profile?.completed === true
      : item.key === 'profile' && clubManaged
        ? options.externalPaymentReady === true
        : checklist?.[item.key]?.completed === true,
    canManage: allowed.has(item.permission),
    }));
}

export function isClubLaunchChecklistComplete(checklist = {}) {
  return CLUB_LAUNCH_CHECKLIST.every(({ key }) => checklist?.[key]?.completed === true);
}
